import React, { PropsWithChildren, useContext, useMemo } from 'react'

import { IEmailLogApp } from '@barracuda-internal/converged-email-log/dist/react/ui/EmailLogProvider'

interface IEmailLogBridge {
  getApp(): IEmailLogApp
  setApp(app: IEmailLogApp): void
}

const EmailLogBridge = (): IEmailLogBridge => {
  let mApp: IEmailLogApp | null = null

  const getApp = () => {
    if (mApp === null) {
      throw new Error('No app configured for email log')
    }
    return mApp
  }

  const setApp = (app: IEmailLogApp): void => {
    mApp = app
  }

  return Object.freeze({
    getApp,
    setApp
  })
}

const EmailLogBridgeContext = React.createContext<IEmailLogBridge | null>(null)

export const useEmailLogBridge = () => {
  const emailLogBridge = useContext(EmailLogBridgeContext)

  if (!emailLogBridge) {
    throw new Error('No bridge configured for email log')
  }

  return emailLogBridge
}

export const useEmailLogApp = () => {
  const emailLogBridge = useEmailLogBridge()
  const app = emailLogBridge.getApp()
  if (!app) {
    throw new Error('No app configured for email log')
  }
  return emailLogBridge.getApp()
}

const EmailLogBridgeProvider = ({ children }: PropsWithChildren) => {
  const emailLogBridge = useMemo(() => EmailLogBridge(), [])

  return <EmailLogBridgeContext.Provider value={emailLogBridge}>{children}</EmailLogBridgeContext.Provider>
}

export default EmailLogBridgeProvider
